import pageHeader from "../components/pageHeader/locals/ar.json";
import contactUsForm from "../components/contactUsForm/locals/ar.json";
import contactUsInfo from "../components/contactUsInfo/locals/ar.json";

export default {
  pageHeader,
  contactUsForm,
  contactUsInfo
};